import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { authHeaders, axiosInstance, logError } from '../../utils/helper';

const initialState = {
	list: [],
	isLoadingList: false,

	detail: {
    outlets: [],
    page: 1,
    total_pages: 0,
  },
	isLoadingDetail: false,
  isLoadMoreDetail: false,
};

export const getCategoryList = createAsyncThunk('category/getCategoryList', async (params) => {
	const res = await axiosInstance.get('food-categories', { params });
	const data = await res.data;
	return data;
});

export const getCategoryDetail = createAsyncThunk('category/getCategoryDetail', async (params, { getState }) => {
	const { page = 1, limit = 10, isLoadMore = false } = params;

  const res = await axiosInstance.get('food-categories/detail', { params, headers: authHeaders().headers });
	const { status, result } = res?.data || {};

  const currentState = getState()?.category?.detail?.outlets || [];
  if (status === 'ok') {
    const newItems = isLoadMore ? result?.outlets?.filter((item) => !currentState.some((outlet) => outlet.storeID === item.storeID)) : result?.outlets || [];

		return {
			outlets: isLoadMore ? [...currentState, ...newItems] : newItems,
			totalPages: result?.total_pages || 0,
			page,
			total: Number(result?.total) || 0,
			limit,
			isLoadMore,
		};
  }
});

const category = createSlice({
	name: 'category',
	initialState,
	reducers: {
		setCategory: (state, action) => {
			return { ...state, ...action.payload };
		},
		clearCategory: () => {
			return initialState;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getCategoryList.pending, (state) => {
				state.isLoadingList = true;
			})
			.addCase(getCategoryList.fulfilled, (state, action) => {
				state.isLoadingList = false;
				state.list = action.payload.result;
			})
			.addCase(getCategoryList.rejected, (state) => {
				state.isLoadingList = false;

        // logError(new Error(action.error?.message), {
        //   feature: "getCategoryList",
        //   actionType: action.type,
        // });
			})
			.addCase(getCategoryDetail.pending, (state, action) => {
        const isLoadMore = action?.meta?.arg?.isLoadMore || false;
        if (isLoadMore) {
          state.isLoadMoreDetail = true;
        } else {
          state.isLoadingDetail = true;
        }
			})
			.addCase(getCategoryDetail.fulfilled, (state, action) => {
				state.isLoadingDetail = false;
				state.isLoadMoreDetail = false;
        state.detail = action.payload;
			})
			.addCase(getCategoryDetail.rejected, (state, action) => {
        const isLoadMore = action?.meta?.arg?.isLoadMore || false;
        if (isLoadMore) {
          state.isLoadMoreDetail = false;
        } else {
          state.isLoadingDetail = false;
        }
        // logError(new Error(action.error?.message), {
        //   feature: "getCategoryDetail",
        //   actionType: action.type,
        // });
			});
	},
});

// Export actions and reducer
export const { setCategory, clearCategory } = category.actions;
export default category.reducer;
